module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Team Name"
    },
    model: {
      value: (_vm.team.name),
      callback: function($$v) {
        _vm.$set(_vm.team, "name", $$v)
      },
      expression: "team.name"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d0c3f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/BulkUpdateDialog.vue
// module id = 2455
// module chunks = 1